import axios from "axios";
import {
  VIEWER_USER_TYPE,
  VIEWER_VIEWS_AS,
  isReadRequest,
  isViewer,
  readOnlyAlert,
  setUserType,
} from "./Permission";

// let url = "http://127.0.0.1:8000/api";
// let url = "https://nabil-erp.projectsample.info/public/api";
 let url ="https://nabil-supplychain-hr-accounts-backend.projectsample.info/public/api";
const Http = axios.create({
  url: url,
  baseURL: url,
  headers: {
    Accept: "application/json",
    // "Content-Type": "multipart/form-data",
    // Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
  },
});

// A view only user (admin_viewer) never sends a write request, even if a
// button was missed somewhere in the UI.
Http.interceptors.request.use((config) => {
  if (isViewer() && !isReadRequest(config.method, config.url)) {
    readOnlyAlert();
    return Promise.reject(
      new Error(
        `Blocked ${String(config.method).toUpperCase()} ${config.url}: account has view only access`
      )
    );
  }
  return config;
});

// The logged in user type is served by /staff-type-check (a plain string) and
// /login-staff-detail (an object). Remember the real type here, and hand the
// pages "admin" instead, so a viewer sees every admin screen and menu.
Http.interceptors.response.use((response) => {
  const requestUrl = String(response.config?.url || "");

  if (/staff-type-check/i.test(requestUrl) && typeof response.data === "string") {
    setUserType(response.data);
    if (response.data === VIEWER_USER_TYPE) {
      response.data = VIEWER_VIEWS_AS;
    }
  }

  if (/login-staff-detail/i.test(requestUrl) && response.data && response.data.user_type) {
    setUserType(response.data.user_type);
    if (response.data.user_type === VIEWER_USER_TYPE) {
      response.data = { ...response.data, user_type: VIEWER_VIEWS_AS };
    }
  }

  return response;
});

export default Http;
